import react from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async";
const SelectDropDown = ({
  label,
  selectedOption,
  handleChange,
  options,
  loadOptions,
  loading,
  setLoading,
  styles,
  selectRef,
  placeholder = "Type 3+ letters",
  isSearchable = false,
  inputValue,
  onInputChange,
  disabled,
  ...props
}) => {
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      borderColor: state.isFocused ? "gray" : "black",
      borderWidth: "0",
      borderRadius: "0.3rem",
      "&:hover": {
        borderColor: "gray", // Optional: set border color on hover
      },
    }),
  };

  // const filterOptions = (inputValue) => {
  //   return options && options.length && options?.filter((i) => i.label.toLowerCase().includes(inputValue.toLowerCase()));
  // };
  // const loadFilteredOptions = (inputValue, callback) => {
  //   callback(filterOptions(inputValue));
  // };

  return (
    <>
      <label htmlFor="user-select" className="block text-md ml-3 text-[#242424]">
        {label}
      </label>
      {isSearchable ? (
        <AsyncSelect
          cacheOptions
          loadOptions={loadOptions}
          value={selectedOption}
          onChange={handleChange}
          placeholder={placeholder}
          ref={selectRef}
          isDisabled={disabled}
          styles={customStyles}
          className="text-black custom-focus-reset  border lg:shadow-none rounded-md !focus:outline-none !focus:ring-0 !ring-0"
          isSearchable
          onInputChange={onInputChange}
          {...props}
        />
      ) : (
        <Select
          isSearchable={false}
          options={options}
          value={selectedOption}
          onChange={handleChange}
          placeholder={placeholder}
          ref={selectRef}
          isDisabled={disabled}
          styles={customStyles}
          className="text-black custom-focus-reset  border lg:shadow-none rounded-md !focus:outline-none !focus:ring-0 !ring-0"
          onInputChange={onInputChange}
          {...props}
        />
      )}
    </>
  );
};
export default SelectDropDown;
